import { AfterViewInit, Directive, ElementRef, inject, OnDestroy } from '@angular/core';

const FOCUSABLE =
  'a[href], button:not([disabled]), textarea:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])';

@Directive({
  selector: '[uwFocusTrap]',
  standalone: true,
})
export class FocusTrapDirective implements AfterViewInit, OnDestroy {
  private readonly el = inject(ElementRef<HTMLElement>);
  private previousFocus: HTMLElement | null = null;

  ngAfterViewInit(): void {
    if (typeof document === 'undefined') return;
    this.previousFocus = document.activeElement as HTMLElement | null;
    this.focusFirst();
  }

  ngOnDestroy(): void {
    this.previousFocus?.focus?.();
  }

  onKeydown(event: KeyboardEvent): void {
    if (event.key !== 'Tab') return;
    const focusable = this.getFocusable();
    if (focusable.length === 0) {
      event.preventDefault();
      return;
    }
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    const active = document.activeElement;

    if (event.shiftKey && active === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && active === last) {
      event.preventDefault();
      first.focus();
    }
  }

  private focusFirst(): void {
    const first = this.getFocusable()[0];
    first?.focus();
  }

  private getFocusable(): HTMLElement[] {
    const root = this.el.nativeElement as HTMLElement;
    return Array.from(root.querySelectorAll<HTMLElement>(FOCUSABLE)).filter(
      (el) => el.offsetParent !== null || el.tagName === 'BUTTON',
    );
  }
}
